__turbopack_context__.v({
  "badge": "FsdVda_badge",
  "cart": "FsdVda_cart",
  "icon": "FsdVda_icon",
});
